import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import _ from "lodash";
import { geocodeByPlaceId } from "react-places-autocomplete";
import ReactPlaceField from "./ReactPlaceField";
import { Card, Form, Row } from "react-bootstrap";
var DEFAULT_FIELDS = {
  address_1: "address_1",
  address_2: "address_2",
  city: "city",
  state: "state",
  postal_code: "postal_code",
  country: "country",
  latitude: "latitude",
  longitude: "longitude"
};

var ReactPlaceAutofillField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactPlaceAutofillField, _React$Component);

  function ReactPlaceAutofillField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      id: Math.floor(Math.random() * 100)
    });

    _defineProperty(_assertThisInitialized(_this), "handleFieldChange", function (key, fieldName) {
      return function (event) {
        var propsName = _this.props.name;
        var addressData = _this.props.formData;

        _.set(addressData, fieldName, event.target.value);

        _this.props.onChange && _this.props.onChange(addressData);

        _this.forceUpdate();
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlaceSelect", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address) {
        var _addressData;

        var fieldNames, oldFormData, _extends2, newFormData, _yield$geocodeByPlace, geocode, firstAddress, city, state, country, postalCode, _this$getFieldLocatio, lat, lng, addressData, updateAdjacentFields;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldNames = _this.fieldNames;
                oldFormData = _.get(_assertThisInitialized(_this), "formProps.state.formData", _this.props.formData);

                if (address) {
                  _context.next = 7;
                  break;
                }

                newFormData = _extends({}, oldFormData, (_extends2 = {}, _extends2[fieldNames.address_1] = null, _extends2[fieldNames.address_2] = null, _extends2[fieldNames.postal_code] = null, _extends2[fieldNames.state] = null, _extends2[fieldNames.latitude] = null, _extends2[fieldNames.longitude] = null, _extends2));
                _this.formProps && _this.formProps.setState(newFormData);
                _this.formProps && _this.formProps.onChange(newFormData);
                return _context.abrupt("return");

              case 7:
                _context.next = 9;
                return geocodeByPlaceId(address.placeId);

              case 9:
                _yield$geocodeByPlace = _context.sent;
                geocode = _yield$geocodeByPlace[0];
                firstAddress = _this.getFieldByGeoCode(geocode, ["street_number", "route", "neighborhood"]);
                city = _this.getFieldByGeoCode(geocode, "locality");
                state = _this.getFieldByGeoCode(geocode, "administrative_area_level_1");
                country = _this.getFieldByGeoCode(geocode, "country");
                postalCode = _this.getFieldByGeoCode(geocode, "postal_code");
                _this$getFieldLocatio = _this.getFieldLocation(geocode), lat = _this$getFieldLocatio.lat, lng = _this$getFieldLocatio.lng;
                addressData = (_addressData = {}, _addressData[fieldNames.address_1] = firstAddress, _addressData[fieldNames.address_2] = null, _addressData[fieldNames.postal_code] = postalCode, _addressData[fieldNames.state] = state, _addressData[fieldNames.city] = city, _addressData[fieldNames.country] = country, _addressData[fieldNames.latitude] = lat, _addressData[fieldNames.longitude] = lng, _addressData);
                updateAdjacentFields = _.get(_this.props, "uiSchema.ui:options.updateAdjacentFields") || false;

                if (updateAdjacentFields) {
                  _this.formProps && _this.formProps.onChange(_extends({}, oldFormData, addressData));
                }

                _this.props.onChange(addressData);

                _this.forceUpdate();

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      console.log(value);
      _this.props.onChange && _this.props.onChange(value);
    });

    return _this;
  }

  var _proto = ReactPlaceAutofillField.prototype;

  _proto.getFieldByGeoCode = function getFieldByGeoCode(geocode, placeType) {
    var _this2 = this;

    var addressComponents = geocode.address_components;

    if (_.isArray(placeType)) {
      var placeTerms = _.map(placeType, function (type) {
        return _this2.getAddressComponentByType(addressComponents, type);
      });

      return _.compact(placeTerms).join(", ");
    }

    var selectedComponent = _.find(addressComponents, function (component) {
      return _.includes(component.types, placeType);
    });

    return selectedComponent && selectedComponent.long_name;
  };

  _proto.getAddressComponentByType = function getAddressComponentByType(addressComponents, placeType) {
    var selectedComponent = _.find(addressComponents, function (component) {
      return _.includes(component.types, placeType);
    });

    return selectedComponent && selectedComponent.long_name;
  };

  _proto.getFieldLocation = function getFieldLocation(geocode) {
    var geocodeLocation = geocode.geometry.location;
    var lat = geocodeLocation.lat();
    var lng = geocodeLocation.lng();
    return {
      lat: lat,
      lng: lng
    };
  };

  _proto.render = function render() {
    var showFields = _.get(this.props, "uiSchema.ui:options.showFields", false);

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactPlaceField, {
      schema: this.props.schema,
      uiSchema: this.props.uiSchema,
      onChange: this.handleChange,
      onPlaceSelect: this.handlePlaceSelect
    }), showFields && /*#__PURE__*/React.createElement(Card, {
      key: "a"
    }, /*#__PURE__*/React.createElement(Card.Body, null, this.renderFormFields())));
  };

  _proto.renderFormFields = function renderFormFields() {
    var _this3 = this;

    var propsValue = this.props.formData;
    return _.map(this.fieldNames, function (fieldName, key) {
      return /*#__PURE__*/React.createElement(Row, {
        className: "p-4",
        key: "form-" + _this3.state.id + "-" + key
      }, /*#__PURE__*/React.createElement(Form.Label, null, _.chain(fieldName).split("_").map(_.capitalize).join(" ").value()), /*#__PURE__*/React.createElement(Form.Control, {
        value: propsValue[fieldName] || "",
        onChange: _this3.handleFieldChange(key, fieldName)
      }));
    });
  };

  _createClass(ReactPlaceAutofillField, [{
    key: "formProps",
    get: function get() {
      return _.get(this.props.formContext, "form.current", null);
    }
  }, {
    key: "fieldNames",
    get: function get() {
      var newValues = _.get(this.props, "uiSchema.ui:options.fields", {});

      return _.merge(DEFAULT_FIELDS, newValues);
    }
  }]);

  return ReactPlaceAutofillField;
}(React.Component);

export default ReactPlaceAutofillField;